import ProductBuyCardPrice from "@components/commerce/product/right-panel/buy-card/price/ProductBuyCardPrice";
import type { ProductPrice } from "@graphql/generated/types";
import { H } from "@ecco/ui/a11y-heading";
import { Box } from "@ecco/ui/box";
import { Flex } from "@ecco/ui/flex";
import { useYotpoReviews } from "@components/commerce/reviews/yotpo/useYotpoReviews";
import { ProductBuyCardReviews } from "@components/commerce/product/right-panel/buy-card/reviews/ProductBuyCardReviews";
import AddToWishlist from "@components/commerce/wishlist/AddToWishlist";
import type { Product } from "@lib/product/types";

export interface ProductBuyCardTitleAndPriceProps {
    heading: string;
    price: ProductPrice;
    product: Product;
}

export const ProductBuyCardTitleAndPrice = ({
    heading,
    price,
    product,
}: ProductBuyCardTitleAndPriceProps) => {
    const { isYotpoReviewsEnabled } = useYotpoReviews();

    return (
        <Box
            mb={6}
            w={"100%"}
            data-testid="product-card-titleandprice"
            display="flex"
            flexDirection="column"
            gap={4}
        >
            <Flex alignItems="flex-start" justifyContent="space-between">
                <Box display="flex" flexDirection="column" gap={2}>
                    <H
                        level="h1"
                        textTransform="capitalize"
                        display="flex"
                        flexDirection="column"
                        gap={1.2}
                    >
                        <Box as="div" fontSize="24px" fontWeight="bold" color="black">
                            {product.name}
                        </Box>
                        {heading && (
                            <Box as="div" fontSize="24px" fontWeight={"bold"} color={"gray.500"}>
                                {heading}
                            </Box>
                        )}
                    </H>
                    {isYotpoReviewsEnabled && <ProductBuyCardReviews productKey={product.sku} />}
                </Box>
                <AddToWishlist product={product} size="xs" variant="ghost" />
            </Flex>
            <ProductBuyCardPrice price={price} productId={product.id} />
        </Box>
    );
};
